module.exports = "<div *ngIf=\"visible\" class=\"loading\">Loading&#8230;</div>"